import React, { useState, useEffect } from 'react';
import './CsvViewer.css';

const CsvViewer = ({ csvUrl }) => {
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCsvData = async () => {
      try {
        setLoading(true);
        const response = await fetch(csvUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const csvText = await response.text();
        const lines = csvText.split('\n').filter(line => line.trim() !== '');
        
        if (lines.length > 0) {
          const headers = lines[0].split(',').map(header => header.trim());
          const data = lines.slice(1).map(line => {
            const values = line.split(',').map(value => value.trim());
            const row = {};
            headers.forEach((header, index) => {
              row[header] = values[index] || '';
            });
            return row;
          });
          
          setHeaders(headers);
          setCsvData(data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (csvUrl) {
      fetchCsvData();
    }
  }, [csvUrl]);

  if (loading) {
    return <div className="csv-viewer-loading">データを読み込み中...</div>;
  }

  if (error) {
    return <div className="csv-viewer-error">エラー: {error}</div>;
  }

  return (
    <div className="csv-viewer">
      <h2>CSV データビューアー</h2>
      <div className="csv-table-container">
        <table className="csv-table">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {csvData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <td key={colIndex}>{row[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="csv-info">
        <p>総行数: {csvData.length}</p>
        <p>総列数: {headers.length}</p>
      </div>
    </div>
  );
};

export default CsvViewer; 